import { render, staticRenderFns } from "./reportdept.vue?vue&type=template&id=38fd1db1&"
import script from "./reportdept.vue?vue&type=script&lang=js&"
export * from "./reportdept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports